import axios from "./axios";
export default {
  private: function (count, page) {
    return axios.post("/api/black/mylist", {
      count,
      page
    });
  },
  public: function (page_size, page) {
    return axios.get("/api/black/query/list", {
      params: {
        page_size,
        page
      }
    });
  },
  get: function (uuid) {
    return axios.get("/api/black/query/piece?uuid=" + uuid);
  },
  search: function (key) {
    return axios.get(`/api/black/query/search?keyword=${key}&page=1&page_size=10000`);
  },
  check(id) {
    return axios.post("/api/black/mylist/check", {
      id
    });
  },
  delete(piece_uuid,repositories_uuid) {
    return axios.post("/api/black/private/piece/delete", {
      piece_uuid,
      repositories_uuid
    });
  },
  edit(piece_uuid, data) {
    return axios.post("/api/black/private/piece/edit", {
      piece_uuid,
      ...data
    });
  },
  getRepList() {
    return axios.post("/api/black/private/query/repositories_list");
  },
  createRep(repositories_name, repositories_type, server_host, server_type, captcha) {
    return axios.post("/api/black/private/repositories/new", {
      repositories_name,
      repositories_type,
      server_host,
      server_type,
      captcha
    });
  },
  getRep(uuid, page) {
    return axios.post(`/api/black/private/query/piece_list?page=${page}&page_size=10`, {
      uuid
    });
  },
  editRep(uuid, repositories_name, repositories_type, server_host, server_type) {
    return axios.post("/api/black/private/repositories/edit", {
      uuid,
      repositories_name,
      repositories_type,
      server_host,
      server_type
    });
  },
  getRepInfo(uuid) {
    return axios.post("/api/black/private/query/repositories_info", {
      uuid
    });
  },
  delRep(uuid) {
    return axios.post("/api/black/private/repositories/delete", {
      uuid
    });
  }
};